// src/redux/Admin/companyViewSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessionName: '',
};

const sessionViewSlice = createSlice({
  name: 'sessionView',
  initialState,
  reducers: {
    setsessionName(state, action) {
      state.sessionName = action.payload;
    },
    resetsessionName(state) {
      state.sessionName = '';
    },
  },
});

export const { setsessionName, resetsessionName } = sessionViewSlice.actions;
export default sessionViewSlice.reducer;
